export default "__VITE_ASSET__e_vCgOIl__"